import * as React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  children: any;
  options?: { link: any; text: string }[];
  link?: any;
  list?: boolean;
  handleClick?: any;
  className?: string;
}

export default class Card extends React.Component<Props> {
  static defaultProps = {
    options: [],
    list: false,
    className: '',
  };

  render() {
    const content = (
      <div
        className={`card${this.props.list ? ' card--list-item' : ''} ${
          this.props.className
        }`}
      >
        <div className="card-content">{this.props.children}</div>
        {!this.props.link &&
          this.props.options.length > 0 && (
            <div className="card-footer">
              {this.props.options.map((option, index) => (
                <Link key={index} to={option.link} className="card-footer-item">
                  {option.text}
                </Link>
              ))}
            </div>
          )}
      </div>
    );
    if (this.props.handleClick) {
      return <a onClick={this.props.handleClick}>{content}</a>;
    }
    if (this.props.link) {
      return <Link to={this.props.link}>{content}</Link>;
    }
    return content;
  }
}
